import { useEffect, useState } from 'react'
import { claimSchemaAgentIntro } from '../intro-visit'

export function useSchemaAgentIntro(enabled: boolean) {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (enabled && claimSchemaAgentIntro()) setOpen(true)
  }, [enabled])
  return { open, dismiss: () => setOpen(false) }
}
